import { inject } from 'vue';
import { useModal } from 'vue-final-modal';
import HawkDeletePopup from '~/common/components/organisms/hawk-delete-popup.vue';
import { useDashboardStore } from '~/dashboard/store/dashboard.store.js';

export function useDashboardHelpers() {
  const $t = inject('$t');
  const dashboard_store = useDashboardStore();

  const { open: openDeletePopup, close: closeDeletePopup, patchOptions } = useModal({
    component: HawkDeletePopup,
  });
  function deleteWidget(widget_config) {
    patchOptions(
      {
        attrs: {
          header: $t('Delete Widget'),
          content: `Are you sure you want to delete ${widget_config.data.name || $t('this widget')}? This action cannot be undone.`,
          onClose() {
            closeDeletePopup();
          },
          confirm: async () => {
            await dashboard_store.delete_widget(widget_config);
            closeDeletePopup();
          },
        },
      },
    );
    openDeletePopup();
  }
  return {
    deleteWidget,
  };
}
